'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('~~', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-parse/lib/locate/delete.js
// module id = 241
// module chunks = 96961042003272 139266963665775